import React from 'react';
import {Col, ControlLabel, FormControl, FormGroup} from 'react-bootstrap';
import {actions, Control, Errors} from 'react-redux-form';
import {connect} from 'react-redux';
import RequiredInput from '../common/form/elements/required-input';
import t from '../../data/translations';

class DeliveryAddressPartial extends React.Component {
  componentDidMount() {
    const {dispatch, addressDetails, model} = this.props;

    const deliveryFields = [
      'use_delivery_address',
      'delivery_address_1',
      'delivery_address_2',
      'delivery_address_3',
      'use_delivery_address',
      'delivery_eircode',
      'delivery_county',
      'delivery_town'
    ];

    deliveryFields.forEach((d) => {
      dispatch(actions.load(`${model}.${d}`, addressDetails[d]));
    });
  }

  render() {
    const {use} = this.props;
    return (
      <Col
        className="mg-top-30"
        lg={6}
        style={{
          marginLeft: 0,
          paddingLeft: 0
        }}
      >
        <FormGroup>
          <ControlLabel>
            <Control.checkbox model=".use_delivery_address"/>
            {' '}
            Use alternate delivery address
          </ControlLabel>
          <Errors
            className="errors"
            model=".use_delivery_address"
            show={{touched: true}}
          />
        </FormGroup>
        {use && (
          <div>
            <RequiredInput label="Delivery Address 1" model='.delivery_address_1' placeholder="Delivery Address 1"/>
            <FormGroup>
              <ControlLabel>
                {' '}
                Delivery Address 2
              </ControlLabel>
              <Control.text
                component={FormControl}
                model=".delivery_address_2"
                placeholder="Delivery Address 2"
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                Delivery Address 2
              </ControlLabel>
              <Control.text
                component={FormControl}
                model=".delivery_address_3"
                placeholder="Delivery Address 3"
              />
            </FormGroup>
            <RequiredInput label="County" model='.delivery_county' placeholder="County"/>
            <RequiredInput label={t('eircode')} model='.delivery_eircode' placeholder={t('eircode')}/>
            <RequiredInput label="Town" model='.delivery_town' placeholder="Town"/>
          </div>
        )}
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  use: state.deep.admin_outlet_view.use_delivery_address,
});

export default connect(mapStateToProps)(DeliveryAddressPartial);



// WEBPACK FOOTER //
// ./src/components/delivery-address/delivery-address-partial.jsx